export default "__VITE_ASSET__c79adcd1__"